import { baseUrl } from './config';
import { createBrowserHistory } from 'history';
let options;
if (baseUrl) options = { basename: baseUrl };
export default createBrowserHistory(options);